import { useMemo } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Subject, useSubjectListener } from '../../../../../utils/subject';

export type KioskPhoneEntry = {
  phone: string;
};

const isValidPhone = ({ phone }: { phone: string }) => {
  return !!(phone && phone.length === 4 && isNaN(Number(phone)) === false);
};

export const useKioskPhoneEntryForm = ({
  onPhoneSubmitted,
  onUserActivity,
  resetEvent,
}: {
  onPhoneSubmitted: (phone: string) => void;
  onUserActivity: () => void;
  resetEvent: Subject<void>;
}) => {
  const { register, handleSubmit, control, reset } = useForm<KioskPhoneEntry>();

  const phone = useWatch({ control, name: 'phone' });

  const isValid = useMemo(() => {
    return isValidPhone({ phone });
  }, [phone]);

  const onSubmit = handleSubmit((values, event) => {
    event?.preventDefault();
    if (isValid) {
      onPhoneSubmitted(values.phone);
    }
    onUserActivity();
  });

  useSubjectListener(
    resetEvent,
    () => {
      reset();
    },
    [],
  );

  return { register, onSubmit, isValid };
};
